document.addEventListener('DOMContentLoaded', function() {
  /* CHECKMARKS */
  convertChecklists();

  /* GRADE / CERTIFICATION JS */
  let gradeButton = document.querySelector('.grade');

  if (gradeButton) {
    /* Handle links from the manual where we want the test open by default */
    if (window.location.href.includes("#!")) {
      toggleLayer('certificationTest');
      toggleLayer('grade');
    }

    gradeButton.type = 'button';
    gradeButton.addEventListener('click', gradeTest);

    document.querySelector('#grade-status-pass').querySelector('.button').addEventListener('click', function() {
      updateCart();
    });

    document.querySelector('#grade-status-pass').querySelector('.close').addEventListener('click', function() {
      updateCart();
    });

    // Reset Dawn fixes for sticky scrolling
    document.querySelector('#grade-status-fail').querySelector('.button').addEventListener('click', function() {
      dawnTestReset();
    });

    document.querySelector('#grade-status-fail').querySelector('.close').addEventListener('click', function() {
      dawnTestReset();
    });
  }

  /* LOOK FOR EXTERNAL LINKS -- a la ES6 style */
  [...document.links].forEach(link => {
    if (link.hostname != window.location.hostname) { link.target = '_blank'; }
  });
});

function updateCart() {
  dawnTestReset();
  document.querySelector('#grade').type = 'submit';
  document.querySelector('#grade').click();
  document.querySelector('#grade').type = 'button';
}

function dawnTestFix() {
  let productWrapper = document.querySelector('.product__info-wrapper.scroll-trigger');

  if (productWrapper) {
    productWrapper.classList.remove('scroll-trigger');

    let productSticky = productWrapper.querySelector('product-info');

    if (productSticky) {
      productSticky.classList.remove('product__column-sticky');
    }
  }
}

function dawnTestReset() {
  let productWrapper = document.querySelector('.product__info-wrapper');

  if (productWrapper) {
    productWrapper.classList.add('scroll-trigger');

    let productSticky = productWrapper.querySelector('product-info');

    if (productSticky) {
      productSticky.classList.add('product__column-sticky');
    }
  }
}

function gradeTest() {
  var testResult = false;
  var numberRight = 0;
  var elementToScrollTo = '';

  // Temporary fix for overlay/modal presentation, needs to be paired with dawnTestReset() call as well
  dawnTestFix();

  for (var i=1; i <= answers.length; i++) {
    var radioArray = document.getElementsByName('question' + i);
    for (var j=0; j < radioArray.length; j++) {
      if (radioArray[j].checked) {
        if (String(radioArray[j].value).toLowerCase() == String(answers[i]).toLowerCase()) {
          var hintElement = document.getElementById('question' + i + 'Hint');
          hintElement.style.display = 'none'; numberRight++;
        }

        if (String(radioArray[j].value).toLowerCase() != String(answers[i]).toLowerCase()) {
          var hintElement = document.getElementById('question' + i + 'Hint');
          hintElement.style.display = 'block';

          if (elementToScrollTo == '') {
            elementToScrollTo = hintElement;
          }
        }
      }
    }
  }

  if (numberRight / (answers.length-1) < .8) {
    document.querySelector('#test-percentage-fail').innerHTML = Math.round(numberRight / (answers.length-1) *100);
    window.location.hash = 'grade-status-fail';
  } else {
    document.querySelector('#test-percentage-pass').innerHTML = Math.round(numberRight / (answers.length-1) *100);
    window.location.hash = 'grade-status-pass';
    document.querySelector('#completePurchase').addEventListener('click', function() {
      // document.getElementById('productForm').submit();
      document.querySelector('[data-type="add-to-cart-form"]').submit();
      }, false);
  }

  if (!testResult) {
    var testElement = document.getElementById('certificationTest');
    testElement.style.display = 'block';
    scrollToElement(elementToScrollTo);
  }

  return testResult;
}

function toggleLayer(selector) {
  var selectorElement = document.querySelector('#' + selector);

  if (!selectorElement) {
    selectorElement = document.querySelector('.' + selector);
  }

  var style = selectorElement.style;
  style.display = style.display ? "" : "block";

  return false;
}

function scrollToElement(elementToScrollTo) {
  window.scroll({ top: elementToScrollTo.offsetTop - 100, left: 0, behavior: 'smooth' });
}

/* CUSTOM CHECKMARKS */
function convertChecklists(scopeSelector = '.rich-text__text.rte', root = document) {
  const CHECK = '✓';

  root.querySelectorAll(scopeSelector).forEach(container => {
    // Only inspect <p> elements inside the scoped container — not the whole document.
    container.querySelectorAll('p').forEach(p => {
      if (!p.textContent.includes(CHECK)) return;

      const groups = splitByBr(p);
      const fragment = document.createDocumentFragment();
      let currentChecklist = null;

      groups.forEach(nodes => {
        const text = nodes.map(n => n.textContent).join('').trim();
        const isCheckItem = text.startsWith(CHECK);

        if (isCheckItem) {
          stripLeadingCheckmark(nodes, CHECK);
        } else {
          currentChecklist = null; // non-checkmark line breaks the grouping run
        }

        const newP = document.createElement('p');
        const label = document.createElement('span');
        label.className = 'checklist__label';
        nodes.forEach(n => label.appendChild(n));
        newP.appendChild(label);

        if (isCheckItem) {
          if (!currentChecklist) {
            currentChecklist = document.createElement('div');
            currentChecklist.className = 'checklist';
            fragment.appendChild(currentChecklist);
          }
          currentChecklist.appendChild(newP);
        } else {
          fragment.appendChild(newP);
        }
      });

      p.replaceWith(fragment);
    });
  });

  // Split a <p>'s child nodes into groups, breaking at each <br>.
  function splitByBr(p) {
    const groups = [[]];
    Array.from(p.childNodes).forEach(node => {
      if (node.nodeName === 'BR') {
        groups.push([]);
      } else {
        groups[groups.length - 1].push(node);
      }
    });
    // Drop any empty leading/trailing groups (e.g. stray whitespace nodes).
    return groups.filter(group => group.some(n => n.textContent.trim().length));
  }

  // Remove the "✓" and following whitespace from the first text node in a group.
  function stripLeadingCheckmark(nodes, checkChar) {
    for (const node of nodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes(checkChar)) {
        node.textContent = node.textContent.replace(
          new RegExp(checkChar + '\\s*'), ''
        );
        break;
      }
    }
  }
}